<template>
    <header class="w-logo">
        <a :href="homepageUrl" class="u-logo"><img class="u-img" svg-inline :src="logoUrl" /></a>
    </header>
</template>

<script>
const DEFAULT_APP = "2kog";
const logos = require.context("@/assets/img/logo", false, /\.svg$/);
import { mapGetters } from "vuex";
import { apps } from "@/assets/data/config/app";
export default {
    name: "Logo",
    data: function () {
        return {};
    },
    computed: {
        ...mapGetters(["app"]),
        logoUrl() {
            const appLogo = `./${this.app || DEFAULT_APP}.svg`;
            const defaultLogo = `./${DEFAULT_APP}.svg`;

            return logos.keys().includes(appLogo) ? logos(appLogo) : logos(defaultLogo);
        },
        currentApp() {
            const app = apps.find((item) => item.value === this.app);
            return app || apps.find((item) => item.value === DEFAULT_APP);
        },
        homepageUrl() {
            return this.currentApp.external || "/";
        },
    },
};
</script>

<style lang="less">
.w-logo {
    margin: 20px 0;
    margin-bottom: 40px;
    .flex;
    align-items: center;
    justify-content: center;
    .u-img {
        width: 68%;
        height: 68%;
    }

    .u-logo {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0 2px 6px #e6ecf1;
        .db;
        .flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
